import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue'

// Types
import { Props } from '@/components/ui/Avatar'

// Props
import useThemeClassName from '@/hooks/useThemeClassName'

// Computed

export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
    picture: {},
    theme: {}
  },
  setup(__props: any) {

const props = __props

// Use
const themeClassName = computed(() => useThemeClassName('avatar', props.theme))

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["avatar", [themeClassName.value]])
  }, [
    (_ctx.picture?.length)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.picture
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createBlock(_component_draw_svg, {
          key: 1,
          name: "user"
        }))
  ], 2))
}
}

})